import { defineTokens } from "@pandacss/dev";

// Shadow tokens that derive color from a semantic shadow color via token() lookup.
// Using tokens ensures shadows adapt across themes (e.g., dark mode) without
// hard-coded rgba values spread across components.
export const shadows = defineTokens.shadows({
	/** No shadow */
	none: { value: "0 0 0 0 {colors.shadow/0}" },
	/** Subtle elevation used for hover/raised cards */
	raised: { value: "0 2px 8px 0px {colors.shadow/8}" },
	/** Higher elevation used for floating layers/overlays */
	floating: { value: "0 8px 24px 0px {colors.shadow/16}" },
	/** Stronger, more pronounced shadow for dragged elements */
	drag: { value: "0 12px 28px 0px {colors.shadow/20}" },
	/** Inset shadow for depressed/pressed state */
	depressed: { value: "inset 0 2px 4px 0px {colors.shadow/12}" },
});
